module.exports = {
    routes: [
        {
            path: '/conversations/:id/:open?',
            name: 'conversations.conversation',
            component: require('./pages/Conversation').default,
            meta: { requiresAuth: true },
        },
    ],
};



// WEBPACK FOOTER //
// ./src/taskflex/conversations/routes.js